import React from "react";

export const CustomCheckbox = (props) => {
  const {
    name,
    value,
    label,
    onChange,
    selectedOption,
    labelClassNames,
    inputClassNames,
    isDisable,
  } = props;

  return (
    <label className={labelClassNames}>
      <input
        type="checkbox"
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        checked={selectedOption === value}
        className={inputClassNames}
        disabled={isDisable}
      />
      {label}
    </label>
  );
};
